import React, { useState, useEffect } from "react";
import { TimeField } from "@mui/x-date-pickers";

export const MyTimePicker = (props) => {
  const [selectedDate, setSelectedDate] = useState(props.value ?? null);

  const handleTimeChange = (date) => {
    if (date != "Invalid Date") {
      props.onAccept(date);
    } else props.onAccept(null);
  };

  useEffect(() => {
    setSelectedDate(props.value ? new Date(props.value) : null);
  }, [props.value]);

  let error = props.helperText !== "" && props.helperText !== null && props.helperText !== undefined;
  const className = "w-100 mt-3 mb-3 " + props.className;

  return (
    <TimeField
      ampm={false}
      className={className}
      helperText={props.helperText}
      variant="outlined"
      label={props.label}
      value={selectedDate}
      onChange={handleTimeChange}
      slotProps={{
        textField: {
          required: props.required,
          error: error,
          helperText: props.helperText,
        },
      }}
    />
  );
};
